export default __webpack_public_path__ + "static/media/Shin-straps of the Blood God.1f727182.jpg";